import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

// A table wider than the pane — dotted leaders in a table of contents, many
// columns — scrolls sideways inside its own box instead of being cut off at
// the pane's edge (#755). The pane's own scrollbar is hidden by design, so
// the table has to bring a visible one.
const components: Components = {
  table: ({ node: _node, ...props }) => (
    <div className="overflow-x-auto">
      <table {...props} />
    </div>
  ),
}

interface MarkdownRendererProps {
  content: string
}

export function MarkdownRenderer({ content }: MarkdownRendererProps) {
  return (
    <div className="flex-1 min-h-0 flex flex-col rounded-lg border overflow-hidden" style={{ backgroundColor: 'var(--sidebar-background)', borderColor: 'var(--sidebar-border)' }}>
      <div className="file-preview-content flex-1 overflow-auto">
        <div className="p-6">
          <div className="file-preview-markdown prose prose-sm md:prose-base max-w-none dark:prose-invert prose-headings:font-bold prose-a:text-blue-600 dark:prose-a:text-blue-400">
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
              {content}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  )
}
